import Backbone from 'backbone';
import RouteModel from './RouteModel';

export default Backbone.Collection.extend({
  model: RouteModel,
  /**
   * @memberOf module:Layers
   * @class RoutesCollection
   * @classdesc This component controls the {@link DirectionModel} elements
   * @extends Backbone.Collection
   */
  initialize() {},

  /**
   * When a  {@link RouteModel} is selected, the rest of models of the collection are deselected
   * @memberOf module:Layers.RoutesCollection
   * @function
   * @param {RouteModel} selectedModel - The selected model
   */
  selectModel(selectedModel) {
    this.each((model) => {
      if (model !== selectedModel) {
        model.onDeselect();
        model.setStyle('basicStyle');
      } else {
        model.setStyle('defaultStyle');
      }
    });
  },

  /**
   * Add a new {@link RouteModel} to the collection
   * @memberOf module:Layers.RoutesCollection
   * @function
   * @param {RouteModel} model - The new model instance
   */
  add(model) {
    Backbone.Collection.prototype.add.call(this, model);
  }
});



// WEBPACK FOOTER //
// ./lmm-widget/src/layers/types/models/RoutesCollection.js